export function operacaoExtratoDadosCapaTnqPostosInRequest(params = {}) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/EXTRADADOSCAPATNQPOSTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoExtratoDadosCapaTnqPostos(codigoposto) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/FIND_EXTRADADOSCAPATNQPOSTOS',
    payload: { codigoposto },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoextratodadoscapatnqpostos/FAILED_REQUEST',
  };
}

export function deleteOperacaoExtratoDadosCapaTnqPostos(codigoposto, params) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/DELETE_EXTRADADOSCAPATNQPOSTOS',
    payload: { codigoposto, params },
  };
}

export function updateOperacaoExtratoDadosCapaTnqPostos(operacaoextratodadoscapatnqpostos, params) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/UPDATE_EXTRADADOSCAPATNQPOSTOS',
    payload: { operacaoextratodadoscapatnqpostos, params },
  };
}

export function storeOperacaoExtratoDadosCapaTnqPostos(operacaoextratodadoscapatnqpostos, params) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/STORE_EXTRADADOSCAPATNQPOSTOS',
    payload: { operacaoextratodadoscapatnqpostos, params },
  };
}

export function successInRequest(
  operacaoextratodadoscapatnqpostos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/SUCCESS_IN_REQUEST',
    payload: { operacaoextratodadoscapatnqpostos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoextratodadoscapatnqpostos) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/SUCCESS_REQUEST',
    payload: { operacaoextratodadoscapatnqpostos },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoextratodadoscapatnqpostos/RECORD_FILTERING',
    payload: { params },
  };
}
